"use client";

import { Button, Text } from "@pamperedchef/design-system";
import * as styles from "./stubs.module.scss";

export interface PlpPaginationProps {
	/** Placeholder total result count. */
	total?: number;
	/** Placeholder page size. */
	pageSize?: number;
}

/** STUB pagination — result summary + DS `Button` page-number placeholders. */
export function PlpPagination({
	total = 42,
	pageSize = 20
}: PlpPaginationProps): JSX.Element {
	const shown = Math.min(pageSize, total);
	const pages = ["1", "2", "…", "9", "10"];

	return (
		<nav
			className={`${styles["stackSm"]} ${styles["section"]}`}
			data-component="PlpPagination"
			aria-label="Pagination"
		>
			<div className={styles["pageRow"]}>
				<Button kind="tertiary" size="sm">
					‹
				</Button>
				{pages.map((page, i) => (
					<Button key={i} kind="tertiary" size="sm">
						{page}
					</Button>
				))}
				<Button kind="tertiary" size="sm">
					›
				</Button>
			</div>
			<Text tag="span" styledAs="smr">
				{`Viewing 1-${shown} of ${total} Items`}
			</Text>
		</nav>
	);
}
